import * as recordingsWidget from '@hotjar/webapp/features/Activation/hooks/useRecordingsWidget';
import { getPlaybacks } from './getPlaybacks';

import type { Store } from '../../../store/list/types';

export const reloadRecordings = (store: Store): void => {
  const { site, setRecordings } = store.getState();

  // clear query cache on recordings widget component
  recordingsWidget.clearRecordingsWidgetData(site?.id as number);

  setRecordings([]);
  getPlaybacks(store);
};
